import { AivaSparkleIcon } from "../../shared/components/icons";
import { AI_NOTICE_COPY } from "../content";
import { formatNoticeDate } from "../format";
import styles from "./AiNoticeCard.module.css";

interface AiNoticeCardProps {
  /** Epoch ms of the current acknowledgement, or null when there is none. */
  readonly acknowledgedAt: number | null;
  readonly onOpen: () => void;
  /** AIVA-8663: version of the notice in force; defaults to the built-in notice. */
  readonly version?: string;
}

/** AIVA-6639 — the notice's permanent home under More → "AI and compliance". */
export function AiNoticeCard({ acknowledgedAt, onOpen, version }: Readonly<AiNoticeCardProps>) {
  const when = acknowledgedAt === null ? null : formatNoticeDate(acknowledgedAt);
  return (
    <section className={styles.section} aria-label={AI_NOTICE_COPY.moreSectionTitle}>
      <h3 className={styles.sectionTitle}>{AI_NOTICE_COPY.moreSectionTitle}</h3>
      <button type="button" className={styles.card} onClick={onOpen}>
        <span className={styles.mark} aria-hidden="true">
          <AivaSparkleIcon />
        </span>
        <span className={styles.text}>
          <span className={styles.cardTitle}>{AI_NOTICE_COPY.title}</span>
          <span className={styles.cardMeta}>{AI_NOTICE_COPY.moreCardMeta(when, version)}</span>
        </span>
        <svg className={styles.chevron} viewBox="0 0 16 16" aria-hidden="true">
          <path d="M6 3.5 10.5 8 6 12.5" />
        </svg>
      </button>
    </section>
  );
}
